<template>
    <div>
        <my-form
        class="form-page"
        v-model="form"
        table
        label-width="180px"
        @submit="submitHandler"
        >
           <el-form-item
           label="解密截止时间："
           prop="extjmjstime"
           >
                <el-date-picker
                    v-model="form.tbwjjmjzsj"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择解密截止时间：" size="small"
                    >
                </el-date-picker>
                 <!-- <el-date-picker
                    v-model="form.tbwjjmjzsj"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择解密截止时间：" size="small"
                    :picker-options="{disabledDate,
                    }"
                    v-if="extjmjstime==null"
                    >
                </el-date-picker> -->
           </el-form-item>
              
           <el-form-item
           label="修改原因："
           prop="reason"
           :rules="newRule('修改原因：', 'required','max17')"
           >
                <el-input 
                    type="textarea"
                    v-model="form.reason"
                    placeholder="请输入修改原因"
                 ></el-input>
           </el-form-item>

            <el-form-item label="附件" class="table-full-row">
                <my-upload
                    :file-guid="form.fileguid"
                ></my-upload>
            </el-form-item>

            <template slot="btn" slot-scope="scope">
                <el-button
                @click="saveHandler(scope.submitHandler)"
                type="primary"
                icon="el-icon-circle-check"
                >
                    提交
                </el-button>

                <el-button
                icon="el-icon-circle-close"
                @click="cancle()"
                >
                    取消
                </el-button>
            </template>
        </my-form>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from "@views/mixins/form-page";
import DIALOG_LIST_PAGE from "@views/mixins/dialog-list-page";

export default {
    mixins: [
        DIALOG_LIST_PAGE,
        FORM_PAGE_MIXIN,
    ],
    props: {
        extjmjstime: {
            type: String,
            default:''
        },
        bdcode: {
            type: String,
            default:''
        },
        extkbtime: {
            type: String,
            default:''
        },
    },
    data: () => ({
        form: {
            reason:'',
            fileguid:'',
            tbwjjmjzsj:'',
            bdcode:''
        },
        pickerOptions: {
            disabledDate(time) { //结束时间的禁用
                return time.getTime() <new Date(this.extkbtime).getTime()
            },
            selectableRange:"00:00:00 - 20:59:59"
        },
    }),
    methods: {
        disabledDate(time) {
            return time.getTime() <new Date(this.extkbtime).getTime()
        },
        saveHandler( cb) {
            cb && cb();
        },
        submitHandler() {
            this.$post(`${this.getGetters('mngUrl')}/Zbdl/tuihui/updatejmjzsj.json`,this.form, function (data, res) {
                ShowMsg(res.msg,'success');	
                this.$emit("cancle")
			})
        },
        cancle() {
            this.$emit("cancle")
        }
    },
    created() {
        if(this.extjmjstime!==null){
           this.extjmjstime=this.extjmjstime+':00' 
           this.extkbtime=this.extkbtime+':01' 
        }
        this.form.tbwjjmjzsj=this.extjmjstime
        this.form.bdcode=this.bdcode
        this.$get(`/standalonfile/operate/getfileguid.json`,(data, res) => {
            this.form.fileguid = data;
        })
    },
    mounted() {

    },
};
</script>

<style scoped lang="scss">
/deep/ .table-view[data-v-3acdabe5] .el-form-item:not(.btn-row) .el-form-item__content .el-form-item__error {
    top: 54px;
}
</style>

